/* eslint-disable default-case */
import { notification } from '../constants';
import produce from 'immer';

const notificationInitialState = {
  data: [],
  total: 0,
  page: 1,
  pageSize: 20,
  sort: undefined,
  filter: undefined,
  error: '',
  isFetching: false,
  isFetchingFinished: false
};

const notificationReducer = produce((draft, action) => {
  switch (action.type) {
    // fetch
    case notification.FETCH_NOTIFICATION_REQUEST: {
      draft.error = '';
      draft.isFetching = true;
      break;
    }
    case notification.FETCH_NOTIFICATION_SUCCESS: {
      draft.data = action.notifications.histories;
      draft.total = action.notifications.total;
      draft.page = action.notifications.page;
      draft.pageSize = action.notifications.pageSize;
      draft.sort = action.notifications.sort;
      draft.filter = action.notifications.filter;
      draft.isFetching = false;
      draft.isFetchingFinished = true;
      break;
    }
    case notification.FETCH_NOTIFICATION_FAILED: {
      draft.error = action.error;
      draft.isFetching = false;
      draft.isFetchingFinished = true;
      break;
    }
    case notification.FETCH_NOTIFICATION_STATUS_RESET: {
      draft.isFetchingFinished = false;
      break;
    }
  }
}, notificationInitialState);

export { notificationInitialState };
export default notificationReducer;
